import axiosInstance from "@/api/axios-instance";
import { Region } from "../types/region";

export async function getActiveRegions(): Promise<Region[]> {
  const response = await axiosInstance.get("/region/active");
  if (!response.status.toString().startsWith("2")) {
    throw new Error("active regions are not loaded");
  }
  return response.data as Region[];
}
